import log from 'loglevel'

log.setDefaultLevel(log.levels.TRACE)

export const Logger = log
